import ShimmerTitle from './Title';

export default ShimmerTitle;
